const Main = (resolve) => require(["@/components/main/Main.vue"], resolve);
const Main1 = (resolve) => require(["@/components/main/Main1.vue"], resolve);
const shopMain = (resolve) =>
  require(["@/components/main/shopMain.vue"], resolve);

const productMain = (resolve) =>
  require(["@/module/quickorder/productMain.vue"], resolve);

//主页
const Home = (resolve) => require(["@/module/home/Home.vue"], resolve);
const Home1 = (resolve) => require(["@/module/home/Home1.vue"], resolve);
const EditApply = (resolve) =>
  require(["@/module/home/editApply.vue"], resolve);

//消息
const Message = (resolve) =>
  require(["@/module/message/messageList.vue"], resolve);

//分类
const MenuList = (resolve) => require(["@/module/menu/MenuList.vue"], resolve);
//公告管理
const NoticeList = (resolve) =>
  require(["@/module/notice/noticeList.vue"], resolve);
const NoticeView = (resolve) =>
  require(["@/module/notice/noticeView.vue"], resolve);
// 订单收藏
const CollectView = (resolve) =>
  require(["@/module/collect/CollectView.vue"], resolve);
//订单管理
const ShipmentList = (resolve) =>
  require(["@/module/shipment/shipmentList.vue"], resolve);
const ShipmentView = (resolve) =>
  require(["@/module/shipment/shipmentView.vue"], resolve);
const InvoiceList = (resolve) =>
  require(["@/module/invoice/invoiceList.vue"], resolve);
const InvoiceView = (resolve) =>
  require(["@/module/invoice/invoiceView.vue"], resolve);
const BillingList = (resolve) =>
  require(["@/module/billing/billingList.vue"], resolve);
const BillingView = (resolve) =>
  require(["@/module/billing/billingView.vue"], resolve);
const ContractList = (resolve) =>
  require(["@/module/contract/ContractList.vue"], resolve);
const ContractView = (resolve) =>
  require(["@/module/contract/ContractView.vue"], resolve);

//发货单管理列表  
const ShipmentList1 = (resolve) =>
  require(["@/module/shipment/new_shipmentList.vue"], resolve);
//发货单管理详情
const ShipmentEdit = (resolve) =>
  require(["@/module/shipment/new_shipmentEdit.vue"], resolve);
//订单
const SaleOrderList = (resolve) =>
  require(["@/module/order/saleorderList.vue"], resolve);
const SaleOrderView = (resolve) =>
  require(["@/module/order/saleorderView.vue"], resolve);
const SaleorderchangeView = (resolve) =>
  require(["@/module/order/saleorderchangeView.vue"], resolve);
  const SaleorderlinechangeView = (resolve) =>
  require(["@/module/order/saleorderchangeView.vue"], resolve);
  const SaleOrderLineView = (resolve) =>
  require(["@/module/order/saleorderView.vue"], resolve);

//订单明细
const SaleOrderLineList = (resolve) =>
  require(["@/module/order/SaleorderlineList.vue"], resolve);

  
//模块
const ModuleInfoList = (resolve) =>
  require(["@/module/moduleinfo/new_moduleinfoView.vue"], resolve);
//发货档案 
const ShippingInfoList = (resolve) =>
  require(["@/module/shippinginfo/new_shippinginfoList.vue"], resolve);
//发货单详情
const ShippingInfoEdit = (resolve) =>
  require(["@/module/shippinginfo/new_shippinginfoEdit.vue"], resolve);

//活动
//Campanign KPI
const CampanignKpiList = (resolve) => require(["@/module/activity/new_campanignkpiList.vue"], resolve);
//Campanign KPI详情
const CampanignKpiEdit = (resolve) => require(["@/module/activity/new_campanignkpiEdit.vue"], resolve);
//plan kpi详情
const new_plankpiEdit = (resolve) => require(["@/module/activity/new_plankpiEdit.vue"], resolve);

//排期
const ScheduleplanList = (resolve) => require(["@/module/schedule/new_scheduleplanList.vue"], resolve);
const ScheduleplanEdit = (resolve) => require(["@/module/schedule/new_scheduleplanEdit.vue"], resolve);
const PlankpischeduleEdit = (resolve) => require(["@/module/schedule/new_plankpischeduleEdit.vue"], resolve);


//可操作型号
const AvailableproductList = (resolve) =>
  require(["@/module/availableproduct/new_availableproductList.vue"], resolve);
//可操作型号详情
const AvailableproductEdit = (resolve) =>
  require(["@/module/availableproduct/new_availableproductEdit.vue"], resolve);
//可操作型号申请列表
const AvailableproductApplyList = (resolve) =>
  require(["@/module/availableproduct/new_availableproductApplyList.vue"], resolve);
//可操作型号申请详情
const AvailableproductApplyEdit = (resolve) =>
  require(["@/module/availableproduct/new_availableproductApplyEdit.vue"], resolve);
//授权函 
const authorizationletterList = (resolve) =>
  require(["@/module/authorizationletter/new_authorizationletterList.vue"], resolve);
//授权函编辑页
const authorizationletterEdit = (resolve) =>
  require(["@/module/authorizationletter/new_authorizationletterEdit.vue"], resolve);
//授权函预览页面 
const authorizationletterprint = (resolve) =>
  require(["@/module/authorizationletter/new_authorizationletter_print.vue"], resolve);

//项目列表
const projectList = (resolve) =>
  require(["@/module/project/new_projectList.vue"], resolve);
//项目详情
const projectEdit = (resolve) =>
  require(["@/module/project/new_projectEdit.vue"], resolve);
//项目申请单列表
const projectapplyList = (resolve) =>
  require(["@/module/projectapply/new_projectapplyList.vue"], resolve);
//项目申请单详情
const projectapplyEdit = (resolve) =>
  require(["@/module/projectapply/new_projectapplyEdit.vue"], resolve);
//商机变更 
const oppchangeapplyList = (resolve) =>
  require(["@/module/oppchangeapply/new_oppchangeapplyList.vue"], resolve);
const oppchangeapplyEdit = (resolve) =>
  require(["@/module/oppchangeapply/new_oppchangeapplyEdit.vue"], resolve);
//资金池 
const capitalpoolList = (resolve) =>
  require(["@/module/capitalpool/new_capitalpoolList.vue"], resolve);
const capitalpoolEdit = (resolve) =>
  require(["@/module/capitalpool/new_capitalpoolEdit.vue"], resolve);
//资金分配单 
const capitalallocationList = (resolve) =>
  require(["@/module/capitalallocation/new_capitalallocationList.vue"], resolve);
const capitalallocationEdit = (resolve) =>
  require(["@/module/capitalallocation/new_capitalallocationEdit.vue"], resolve);
//显示地图
const Map = (resolve) =>
  require(["@/module/projectapply/map.vue"], resolve);

const ShoppingMallChooseProduct = (resolve) =>
  require(["@/module/quickorder/chooseProduct.vue"], resolve);
const ShoppingMallSearchProduct = (resolve) =>
  require(["@/module/quickorder/searchProduct.vue"], resolve);
const ProductDetail = (resolve) =>
  require(["@/module/quickorder/productDetail.vue"], resolve);
const OrderConfirm = (resolve) =>
  require(["@/module/quickorder/confirm.vue"], resolve);
const OrderComplete = (resolve) =>
  require(["@/module/quickorder/complete.vue"], resolve);
const ShoppingMallImportProduct = (resolve) =>
  require(["@/module/quickorder/importProduct.vue"], resolve);
//子项目申请单列表
const subprojectapplyList = (resolve) =>
  require(["@/module/subprojectapply/new_subprojectapplyList.vue"], resolve);
//子项目申请单详情
const subprojectapplyEdit = (resolve) =>
  require(["@/module/subprojectapply/new_subprojectapplyEdit.vue"], resolve);
//子项目申请单明细详情
const subprojectapplylineEdit = (resolve) =>
  require(["@/module/subprojectapply/new_subprojectapplylineEdit.vue"], resolve);
//对账管理列表
const reconciliationList = (resolve) =>
  require(["@/module/reconciliation/new_reconciliationList.vue"], resolve);
//对账详情
const reconciliationEdit = (resolve) =>
  require(["@/module/reconciliation/new_reconciliationEdit.vue"], resolve);
//调账管理列表
const adjustsingleList = (resolve) =>
  require(["@/module/adjustsingle/new_adjustsingleList.vue"], resolve);
//调账详情
const adjustsingleEdit = (resolve) =>
  require(["@/module/adjustsingle/new_adjustsingleEdit.vue"], resolve);
//外部用户注册信息列表
const outuserapplyList = (resolve) =>
  require(["@/module/outuserapply/new_outuser_applyList.vue"], resolve);
//外部用户注册信息详情页
const outuserapplyEdit = (resolve) =>
  require(["@/module/outuserapply/new_outuser_applyEdit.vue"], resolve);

//项目批次交付计划列表页
const subdeliveryplanList = (resolve) =>
  require(["@/module/subdeliveryplan/new_sub_deliveryplanList.vue"], resolve);
//项目批次交付计划详情页
const subdeliveryplanEdit = (resolve) =>
  require(["@/module/subdeliveryplan/new_sub_deliveryplanEdit.vue"], resolve);
//项目批次交付计划明细
const subdeliveryplanlineEdit = (resolve) =>
  require(["@/module/subdeliveryplan/new_sub_deliveryplanlineEdit.vue"], resolve);
//项目交付计划
const deliveryplanList = (resolve) =>
  require(["@/module/deliveryplan/new_deliveryplanList.vue"], resolve);
const deliveryplanEdit = (resolve) =>
  require(["@/module/deliveryplan/new_deliveryplanDetail.vue"], resolve);

const ForecastList = (resolve) =>
  require(["@/module/forecast/forecastList.vue"], resolve);
const ForecastView = (resolve) =>
  require(["@/module/forecast/forecastView.vue"], resolve);

const FileDownloadList = (resolve) =>
  require(["@/module/filedownload/filedownloadList.vue"], resolve);
const FileDownloadView = (resolve) =>
  require(["@/module/filedownload/filedownloadView.vue"], resolve);
const ForcecastReport = (resolve) =>
  require(["@/module/forecast/forcecastReport.vue"], resolve);
const SalesmanList = (resolve) =>
  require(["@/module/salesman/salesmanList.vue"], resolve);
const SalesmanView = (resolve) =>
  require(["@/module/salesman/salesmanView.vue"], resolve);
const SalesmanEdit = (resolve) =>
  require(["@/module/salesman/salesmanEdit.vue"], resolve);
const CreateOpportunity = (resolve) =>
  require(["@/module/opportunity/createOpportunity.vue"], resolve);
const OpportunityList = (resolve) =>
  require(["@/module/opportunity/opportunityList.vue"], resolve);
const OpportunityEdit = (resolve) =>
  require(["@/module/opportunity/opportunityEdit.vue"], resolve);
//补件申请
const ResissueApplicationList = (resolve) =>
  require([
    "@/module/resissueapplication/resissueApplicationList.vue",
  ], resolve);
const ResissueApplicationDetail = (resolve) =>
  require([
    "@/module/resissueapplication/resissueApplicationDetail.vue",
  ], resolve);
const QuickOrderList = (resolve) =>
  require(["@/module/quickorder/quickOrderList.vue"], resolve);
const ProPriceList = (resolve) =>
  require(["@/module/proprice/propriceList.vue"], resolve);
const ProPriceView = (resolve) =>
  require(["@/module/proprice/propriceView.vue"], resolve);
//临时额度申请
const TempcreditList = (resolve) =>
  require(["@/module/tempcredit/tempcreditList.vue"], resolve);
const TempcreditView = (resolve) =>
  require(["@/module/tempcredit/tempcreditView.vue"], resolve);
//费用申请
const CostapplyList = (resolve) =>
  require(["@/module/costapply/costapplyList.vue"], resolve);
const CostapplyView = (resolve) =>
  require(["@/module/costapply/costapplyView.vue"], resolve);
//返利管理
const RebatedetailList = (resolve) =>
  require(["@/module/rebatedetail/rebatedetailList.vue"], resolve);
//财务管理   对账单
const AccountStatementList = (resolve) =>
  require(["@/module/accountstatement/accountstatementList.vue"], resolve);
const AccountStatementDetail = (resolve) =>
  require(["@/module/accountstatement/accountstatementDetail.vue"], resolve);
const ResetPasswordView = (resolve) =>
  require(["@/module/resetpassword/ResetPasswordView.vue"], resolve);
const ShoppingCartList = (resolve) =>
  require(["@/module/quickorder/shoppingCartList.vue"], resolve);
//报价单配置
const QuotationConfigList = (resolve) =>
  require(["@/module/quotationconfig/quotationConfigList.vue"], resolve);
const QuotationConfigDetail = (resolve) =>
  require(["@/module/quotationconfig/quotationConfigDetail.vue"], resolve);
const QuoteDetails = (resolve) =>
  require(["@/module/productCatalog/QuoteDetails.vue"], resolve);
const productCatalogIndex = (resolve) =>
  require(["@/module/productCatalog/productCatalogIndex.vue"], resolve);
const collectList = (resolve) =>
  require(["@/module/productCatalog/collectList.vue"], resolve);
const vehicleVarConfigList = (resolve) =>
  require(["@/module/productCatalog/vehicleVarConfigList.vue"], resolve);
const contractConfigList = (resolve) =>
  require(["@/module/productCatalog/ApplicationConfig.vue"], resolve);
//特殊订单释放申请 add by christine liang at  2021-08-05 
// 列表 
const SpecialOrderApplyList = (resolve) =>
  require(["@/module/specialorderapply/new_specialorder_applyList.vue"], resolve);
//详情
const SpecialOrderApplyEdit = (resolve) =>
  require(["@/module/specialorderapply/new_specialorder_applyEdit.vue"], resolve);
//订单承诺
//列表
const SaleordercommitmentList = (resolve) =>
  require(["@/module/saleordercommitment/new_ord_saleordercommitmentList.vue"], resolve);
//详情
const SaleordercommitmentEdit = (resolve) =>
  require(["@/module/saleordercommitment/new_ord_saleordercommitmentEdit.vue"], resolve);

//add by christine liang  at 2021.10.15
//回款信息列表  
const BSHBillingList = (resolve) =>
  require(["@/module/billing/new_ord_billingList.vue"], resolve);
//回款信息详情
const BSHBillingEdit = (resolve) =>
  require(["@/module/billing/new_ord_billingEdit.vue"], resolve);

export default [
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          keepAlive: true,
          allowAnonymous: true,
        },
        component: Home,
      },
    ],
  },
  {
    path: "/home1",
    component: getViews("Main"),
    children: [
      {
        path: "/home1",
        name: "home1",
        component: Home1,
      },
    ],
  },
  {
    path: "/edit",
    component: getViews("Main"),
    children: [
      {
        path: "apply",
        name: "editApply",
        component: EditApply,
      },
    ],
  },
  {
    path: "/message",
    component: getViews("Main"),
    children: [
      {
        path: "message",
        name: "message",
        meta: {
          keepAlive: true,
        },
        component: Message,
      },
    ],
  },
  {
    path: "/menu",
    component: getProductViews("productMain"),
    children: [
      {
        path: "menulist",
        name: "menu-list",
        meta: {
          allowAnonymous: true,
        },
        component: MenuList,
      },
    ],
  },
  {
    path: "/notice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "NoticeList",
        component: NoticeList,
      },
      {
        path: "view/:id",
        name: "notice-detail",
        component: NoticeView,
      },
    ],
  },
  {
    path: "/shoppingmall",
    component: getProductViews("productMain"),
    children: [
      {
        path: "chooseproduct/:name?/:id?",
        name: "ShoppingMallChooseProduct",
        meta: {
          allowAnonymous: true,
        },
        component: ShoppingMallChooseProduct,
      },
      {
        path: "searchproduct/:name?",
        name: "ShoppingMallSearchProduct",
        meta: {
          allowAnonymous: true,
        },
        component: ShoppingMallSearchProduct,
      },
      {
        path: "productdetail",
        name: "product-detail",
        meta: {
          allowAnonymous: true,
        },
        component: ProductDetail,
      },
    ],
  },
  {
    path: "/collect",
    component: getViews("Main"),
    children: [
      {
        path: "view",
        name: "collect-view",
        component: CollectView,
      },
    ],
  },

  {
    path: "/shipment",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ShipmentList",
        component: ShipmentList,
      },
      {
        path: "view/:id",
        name: "ShipmentView",
        component: ShipmentView,
      },
    ],
  },
  {
    path: "/invoice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "InvoiceList",
        component: InvoiceList,
      },
      {
        path: "view/:id",
        name: "InvoiceView",
        component: InvoiceView,
      },
    ],
  },
  {
    path: "/billing",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "BillingList",
        component: BillingList,
      },
      {
        path: "view/:id",
        name: "BillingView",
        component: BillingView,
      },
    ],
  },
  //订单 
  {
    path: "/order",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SaleOrderList",
        component: SaleOrderList,
      },
      {
        path: ":id/detail",
        name: "SaleOrderView",
        component: SaleOrderView,
      },
      {
        path: ":id/:type/detail",
        name: "SaleOrderLineView",
        component: SaleOrderLineView,
      },
      {
        path: ":id/:new_changetype/orderchange",
        name: "SaleorderchangeView",
        component: SaleorderchangeView,
      },
      {
        path: ":id/:new_changetype/:type/orderchange",
        name: "SaleorderlinechangeView",
        component: SaleorderlinechangeView,
      }
    ],
  },
    //订单 
    {
      path: "/orderline",
      component: getViews("Main"),
      children: [
        {
          path: "list",
          name: "SaleOrderLineList",
          component: SaleOrderLineList,
        },
      ],
    },
  

  {
    path: "/moduleinfo",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ModuleInfoList",
        component: ModuleInfoList,
      },

    ],
  },
  //发货单
  {
    path: "/shippinginfo",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ShippingInfoList",
        component: ShippingInfoList,
      },
      {
        path: ":id/detail",
        name: "ShippingInfoEdit",
        component: ShippingInfoEdit,
      },
    ],
  },
  //活动
  {
    path: "/activity",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "CampanignKpiList",
        component: CampanignKpiList,
      },
      {
        path: ":id/detail",
        name: "CampanignKpiEdit",
        component: CampanignKpiEdit,
      },
      {
        path: ":id/:campanignkpiid/details",
        name: "new_plankpiEdit",
        component: new_plankpiEdit,
      },
    ],
  },
  //排期
  {
    path: "/schedule",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ScheduleplanList",
        component: ScheduleplanList,
      },
      {
        path: ":id/detail",
        name: "ScheduleplanEdit",
        component: ScheduleplanEdit,
      },
      {
        path: ":id/:campanignkpiid/details",
        name: "PlankpischeduleEdit",
        component: PlankpischeduleEdit,
      },
    ],
  },
  //可操作型号
  {
    path: "/availableproduct",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "AvailableproductList",
        component: AvailableproductList,
      }
      ,
      {
        path: ":id/detail",
        name: "AvailableproductEdit",
        component: AvailableproductEdit,
      },
      {
        path: "applylist",
        name: "AvailableproductApplyList",
        component: AvailableproductApplyList,
      },
      {
        path: ":id/applydetail",
        name: "AvailableproductApplyEdit",
        component: AvailableproductApplyEdit,
      },
    ],
  },
  //授权函 authorizationletterList
  {
    path: "/authorizationletter",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "authorizationletterList",
        component: authorizationletterList,
      },
      {
        path: ":id/detail",
        name: "authorizationletterEdit",
        component: authorizationletterEdit,
      },
      {
        path: ":oppid/:oppname/create",
        name: "authorizationletterCreate",
        component: authorizationletterEdit,
      },
      {
        path: "print",
        name: "authorizationletterprint",
        meta: {
          allowAnonymous: true,
        },
        component: authorizationletterprint,
      },
    ],
  },
  //项目申请单 
  {
    path: "/projectapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "projectapplyList",
        component: projectapplyList,
      },
      {
        path: ":id/detail",
        name: "projectapplyEdit",
        component: projectapplyEdit,
      },
      {
        path: "baidumap",
        name: "baidumap",
        meta: {
          allowAnonymous: true,
        },
        component: Map,
      },
    ],
  },
  //项目 
  {
    path: "/project",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "projectList",
        component: projectList,
      },
      {
        path: ":id/detail",
        name: "projectEdit",
        component: projectEdit,
      },

    ],
  },
  //商机变更 
  {
    path: "/oppchangeapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "oppchangeapplyList",
        component: oppchangeapplyList,
      },
      {
        path: ":id/detail",
        name: "oppchangeapplyEdit",
        component: oppchangeapplyEdit,
      },
    ],
  },
  //资金池 
  {
    path: "/capitalpool",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "capitalpoolList",
        component: capitalpoolList,
      },
      {
        path: ":id/detail",
        name: "capitalpoolEdit",
        component: capitalpoolEdit,
      },
    ],
  },
  //资金分配单 
  {
    path: "/capitalallocation",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "capitalallocationList",
        component: capitalallocationList,
      },
      {
        path: ":id/detail",
        name: "capitalallocationEdit",
        component: capitalallocationEdit,
      },
    ],
  },

  //子项目申请单
  {
    path: "/subprojectapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "subprojectapplyList",
        component: subprojectapplyList,
      },
      {
        path: ":projectid/:projectname/create",
        name: "subprojectapplyCreate",
        component: subprojectapplyEdit,
      },
      {
        path: ":id/detail",
        name: "subprojectapplyEdit",
        component: subprojectapplyEdit,
      },
      {
        path: ":id/:applyid/:applyname/:status/linedetail",
        name: "subprojectapplylineEdit",
        component: subprojectapplylineEdit,

        path: ":id/linedetail",
        name: "subprojectapplylineEdit",
        component: subprojectapplylineEdit,
      }
    ],

  },

  //对账管理
  {
    path: "/reconciliation",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "reconciliationList",
        component: reconciliationList,
      },
      {
        path: ":id/detail",
        name: "reconciliationEdit",
        component: reconciliationEdit,
      }
    ],

  },
  //对账管理
  {
    path: "/adjustsingle",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "adjustsingleList",
        component: adjustsingleList,
      },
      {
        path: ":id/detail",
        name: "adjustsingleEdit",
        component: adjustsingleEdit,
      }
    ],

  },
  //发货单管理  add by christine liang at 2021.07.28
  {
    path: "/shipment1",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ShipmentList1",
        component: ShipmentList1,
      },
      {
        path: ":id/detail",
        name: "ShipmentEdit",
        component: ShipmentEdit,
      }
    ],
  },
  //特殊订单释放申请  add by christine liang at 2021.08.05
  {
    path: "/specialorderapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SpecialOrderApplyList",
        component: SpecialOrderApplyList,
      },
      {
        path: ":id/detail",
        name: "SpecialOrderApplyEdit",
        component: SpecialOrderApplyEdit,
      }
    ],
  },
  //订单承诺  add by christine liang at 2021.08.16
  {
    path: "/saleordercommitment",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SaleordercommitmentList",
        component: SaleordercommitmentList,
      },
      {
        path: ":id/detail",
        name: "SaleordercommitmentEdit",
        component: SaleordercommitmentEdit,
      }
    ],
  },
  //外部用户  add by christine liang at 2021.09.13
  {
    path: "/outuserapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "outuserapplyList",
        component: outuserapplyList,
      },
      {
        path: ":id/detail",
        name: "outuserapplyEdit",
        component: outuserapplyEdit,
      }
    ],
  },
  //项目批次交付计划
  {
    path: "/subdeliveryplan",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "subdeliveryplanList",
        component: subdeliveryplanList,
      },
      {
        path: ":id/detail",
        name: "subdeliveryplanEdit",
        component: subdeliveryplanEdit,
      },
      {
        path: ":id/:applyid/:applyname/linedetail",
        name: "subdeliveryplanlineEdit",
        component: subdeliveryplanlineEdit,

        path: ":id/linedetail",
        name: "subdeliveryplanlineEdit",
        component: subdeliveryplanlineEdit,
      }
    ],
  },
  //项目交付计划 
  {
    path: "/deliveryplan",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "deliveryplanList",
        component: deliveryplanList,
      },
      {
        path: ":id/detail",
        name: "deliveryplanEdit",
        component: deliveryplanEdit,
      },
    ],
  },
  //回款信息  add by christine liang at 2021.10.15
  {
    path: "/bshbilling",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "BSHBillingList",
        component: BSHBillingList,
      },
      {
        path: ":id/detail",
        name: "BSHBillingEdit",
        component: BSHBillingEdit,
      }
    ],
  },
  {
    path: "/shopcart",
    component: getViews("shopMain"),
    children: [
      {
        path: "list",
        name: "ShoppingCartList",
        component: ShoppingCartList,
      },
    ],
  },
  {
    path: "/confirm",
    component: getProductViews("OrderConfirm"),
    children: [
      {
        path: ":id/order",
        name: "OrderConfirm",
        component: OrderConfirm,
      },
    ],
  },
  {
    path: "/quickorder",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "QuickOrderList",
        component: QuickOrderList,
      },
      ,
      {
        path: "importproduct",
        meta: {
          keepAlive: true,
          allowAnonymous: true,
        },
        component: ShoppingMallImportProduct,
      },
    ],
  },
  {
    path: "/contract",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ContractList",
        component: ContractList,
      },
      {
        path: "view/:id",
        name: "ContractView",
        component: ContractView,
      },
    ],
  },
  {
    path: "/proprice",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ProPriceList",
        component: ProPriceList,
      },
      {
        path: "create",
        name: "ProPriceCreate",
        component: ProPriceView,
      },
      {
        path: "view/:id",
        name: "proprice-detail",
        component: ProPriceView,
      },
    ],
  },
  {
    path: "/salesforecast",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ForecastList",
        component: ForecastList,
      },
      {
        path: "view/:id",
        name: "ForecastView",
        component: ForecastView,
      },
      {
        path: "create",
        name: "ForecastCreate",
        component: ForecastView,
      },
      {
        path: "report",
        name: "ForcecastReport",
        component: ForcecastReport,
      },
    ],
  },
  {
    path: "/filedownload",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "FileDownloadList",
        component: FileDownloadList,
      },
      {
        path: "view/:id",
        name: "FileDownloadView",
        component: FileDownloadView,
      },
    ],
  },
  {
    path: "/salesman",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "SalesmanList",
        component: SalesmanList,
      },
      {
        path: "Edit/:id",
        name: "SalesmanEdit",
        component: SalesmanEdit,
      },
      {
        path: "view",
        name: "SalesmanView",
        component: SalesmanView,
      },
    ],
  },
  {
    path: "/opportunity",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "OpportunityList",
        component: OpportunityList,
      },
      {
        path: "edit/:id",
        name: "OpportunityEdit",
        component: OpportunityEdit,
      },
      {
        path: ":projectid/:projectname/create",
        name: "opportunityCreate",
        component: OpportunityEdit,
      },
      {
        path: ":projectid/:projectname/:subprojectid/:subprojectname/create",
        name: "CreateOpportunity",
        component: OpportunityEdit,
      },
    ],
  },
  {
    path: "/resissueapplication",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "ResissueApplicationList",
        component: ResissueApplicationList,
      },
      {
        path: "detail/:id",
        name: "ResissueApplicationDetail",
        component: ResissueApplicationDetail,
      },
    ],
  },
  {
    path: "/tempcredit",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "TempcreditList",
        component: TempcreditList,
      },
      {
        path: "view/:id",
        name: "tempcredit-detail",
        component: TempcreditView,
      },
      {
        path: "create",
        name: "TempcreditCreate",
        component: TempcreditView,
      },
    ],
  },
  {
    path: "/costapply",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "CostapplyList",
        component: CostapplyList,
      },
      {
        path: "view/:id",
        name: "costapply-detail",
        component: CostapplyView,
      },
      {
        path: "create",
        name: "CostapplyCreate",
        component: CostapplyView,
      },
    ],
  },
  {
    path: "/rebatedetail",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "RebatedetailList",
        component: RebatedetailList,
      },
    ],
  },
  {
    path: "/accountstatementlist",
    component: getViews("Main"),
    children: [
      {
        path: "list",
        name: "accountstatementList",
        component: AccountStatementList,
      },
    ],
  },
  {
    path: "/accountstatementDetail/:id/:date",
    component: getViews("Main"),
    children: [
      {
        path: "detail",
        name: "accountstatement-detail",
        component: AccountStatementDetail,
      },
    ],
  },
  {
    path: "/resetpassword",
    component: getViews("Main"),
    children: [
      {
        path: "view",
        name: "resetpassword-view",
        component: ResetPasswordView,
      },
    ],
  },
  //配置报价
  {
    path: "/quotationconfig/list",
    name: "quotationconfiglist",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigList,
  },
  {
    path: "/quotationconfig/create/:quoteId?",
    name: "quotationconfigcreate",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigDetail,
  },
  {
    path: "/quotationconfig/edit/:quoteId?/:cpqQuoteId?",
    name: "quotationconfigedit",
    meta: {
      allowAnonymous: true,
    },
    component: QuotationConfigDetail,
  },
  {
    path: "/quote/details/:cpqQuoteId?",
    name: "quotedetails",
    meta: {
      allowAnonymous: true,
    },
    component: QuoteDetails,
  },
  {
    path: "/product/catalog",
    name: "productcatalog",
    meta: {
      allowAnonymous: true,
    },
    component: productCatalogIndex,
  },
  {
    path: "/collect/list",
    name: "collectlist",
    meta: {
      allowAnonymous: true,
    },
    component: collectList,
  },
  {
    path: "/config/page",
    name: "configpage",
    meta: {
      allowAnonymous: true,
    },
    component: vehicleVarConfigList,
  },
  {
    path: "/config/linepage",
    name: "configlinepage",
    meta: {
      allowAnonymous: true,
    },
    component: contractConfigList,
  },
];
import store from "../store";

function getViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return (resolve) =>
      require(["@/components/main/" + path + ".vue"], resolve);
  } else {
    return (resolve) => require(["@/components/main/Main1.vue"], resolve);
  }
}

function getProductViews(path) {
  const isStore = store.state.isStore;
  if (isStore) {
    return (resolve) =>
      require(["@/module/quickorder/" + path + ".vue"], resolve);
  } else {
    return (resolve) => require(["@/components/main/Main1.vue"], resolve);
  }
}



// WEBPACK FOOTER //
// ./src/module/router.js